var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserGuideComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6460_8052)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3337 9.23843V10.0051C18.3326 11.8021 17.7507 13.5507 16.6748 14.99C15.5988 16.4292 14.0864 17.4822 12.3631 17.9917C10.6399 18.5012 8.79804 18.44 7.11238 17.8172C5.42673 17.1945 3.98754 16.0435 3.00946 14.536C2.03138 13.0285 1.56682 11.2451 1.68506 9.45202C1.80329 7.6589 2.498 5.95203 3.66556 4.58599C4.83312 3.21994 6.41098 2.26791 8.16382 1.87188C9.91665 1.47585 11.7505 1.65704 13.392 2.38843",
    stroke: "#59C7C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33301L10 11.6747L7.5 9.17467",
    stroke: "#59C7C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6460_8052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserGuideComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/userGuide-complete.7f7f9f6b8d1b48eb322788c2538adac6.svg";